import { TimeClockCircleIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { dateNotationSelector } from 'selectors/current_user';
import { userDateFormatCheckYear } from 'services/time_format';
const spotTimeContainerCss = "s148oru3";
const SpotTimeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(spotTimeContainerCss, props.className)} />;
});
const spotGroupBodyCss = "s1sn9284";
const SpotGroupBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(spotGroupBodyCss, props.className)} />;
});
const spotGroupCss = "siw3flt";
const SpotGroup = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(spotGroupCss, props.className)} />;
});
const clockIconCss = "ce0l3le";
const ClockIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(clockIconCss, props.className)}>
      <TimeClockCircleIcon />
    </Component>;
});
export const SpotsSummary = ({
  groupedSpots,
  timezone
}) => {
  const dateNotation = useSelector(dateNotationSelector);
  return <div>
      {groupedSpots.map(group => {
      const date = userDateFormatCheckYear(moment(group.date).tz(timezone), dateNotation);
      const groupKey = moment(group.date).tz(timezone).format('YYYY-MM-DD');
      return <SpotGroup key={date} data-component={`${groupKey}-group`}>
            <BodyText weight="bold">{date}</BodyText>
            <SpotGroupBody>
              <ClockIcon />
              <SpotTimeContainer>
                {group.spots.map(spot => <div key={spot.startTime}>
                    {spot.startTime.replace(/^0+/, '')}
                  </div>)}
              </SpotTimeContainer>
            </SpotGroupBody>
          </SpotGroup>;
    })}
    </div>;
};

require("./spots_summary.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./spots_summary.js");